<template>
  <div ref="card" class="agent-photo-id-card">
    <div class="role">{{ roleLabel }}</div>
    <div class="photo-frame">
      <img v-if="photoSrc" :src="photoSrc" alt="" />
    </div>
    <div class="logo">
      <img :src="logoSrc" alt="SmartTransyt" />
    </div>
    <div class="id-line">ID: {{ idNumber }}</div>
    <div class="name-bar"><span class="name-text">{{ bannerName }}</span></div>
    <div class="footer" :style="{ backgroundColor: infoColor }">
      <div>Dial *447*558#</div>
      <div>or download the app at:</div>
      <div>www.smarttransyt.com</div>
    </div>
  </div>
</template>

<script>
import src from './src'
export default src
</script>

<style scoped>
.agent-photo-id-card {
  position: relative;
  width: 1012px;
  height: 638px;
  background: #ffffff;
  color: #204da2;
  font-family: Arial, Helvetica, sans-serif;
  overflow: hidden;
  border-radius: 25px;
}

.role {
  position: absolute;
  left: 30px;
  top: 22px;
  width: 380px;
  height: 57px;
  font-size: 54px;
  font-weight: 800;
  line-height: 57px;
  color: #204da2;
}

.photo-frame {
  position: absolute;
  left: 30px;
  top: 89px;
  width: 360px;
  height: 519px;
  border: 8px solid #204da2;
  border-radius: 28px;
  overflow: hidden;
  background: #ffffff;
  box-sizing: border-box;
}

.photo-frame img {
  position: absolute;
  display: block;
  max-width: none;
  max-height: none;
}

.logo {
  position: absolute;
  left: 422px;
  top: 21px;
  width: 560px;
  height: 112px;
  overflow: hidden;
}

.logo img {
  position: absolute;
  display: block;
  max-width: none;
  max-height: none;
}

.id-line {
  position: absolute;
  left: 422px;
  top: 149px;
  width: 560px;
  box-sizing: border-box;
  padding: 0 24px;
  font-size: 42px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 50px;
  color: #204da2;
  white-space: nowrap;
}

.name-bar {
  position: absolute;
  left: 422px;
  top: 211px;
  width: 590px;
  height: 96px;
  box-sizing: border-box;
  overflow: hidden;
  background: #204da2;
  color: #ffffff;
  font-size: 44px;
  font-weight: 700;
  line-height: 52px;
  white-space: nowrap;
  padding: 22px 24px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.footer {
  position: absolute;
  left: 422px;
  top: 319px;
  width: 590px;
  height: 289px;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 44px;
  font-weight: 700;
  line-height: 1.35;
  padding: 28px 24px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}
</style>
